import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import * as UserActions from "../../store/actions/User";
import * as RiderTdsCertificatesActions from "../../store/actions/RiderTdsCertificates";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TdsCertificatesList from "../../components/TdsCertificates/index";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import { isValNull } from "../../utils/index";

const DriverTdsCertificates = (props) => {
  const { setStatus, getTdsCertificates, tdsCertificates } = props;
  const [driverId, setDriverId] = useState("");

  const handleChange = (val) => {
    setDriverId(val);
  };

  const handleClick = () => {
    if (isValNull(driverId)) {
      setStatus({ type: "error", message: "Please Enter Driver Id" });
      return;
    }

    if (driverId.toLowerCase().includes("fe")) {
      setStatus({ type: "error", message: "Please Enter Driver ID not FE ID" });
      return;
    }

    getTdsCertificates(driverId);
  };

  return (
    <div className="Driver-Tags-View container">
      <FlexContainer align="flex-start">
        <Heading>Driver TDS Certificates</Heading>
        <div className="mb-20 flex items-center justify-end">
          <Input
            value={driverId}
            data-testid="driverId"
            id="sushi-input"
            onChange={(e) => handleChange(e)}
            label="Driver ID"
          />
          <div className={"mb-20"}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn mb-10"
              data-testid="tdsCertificateSubmitBtn"
            >
              Submit
            </Button>
          </div>
        </div>
      </FlexContainer>
      <TdsCertificatesList list={tdsCertificates} />
    </div>
  );
};

function mapStateToProps(state) {
  const { RiderTdsCertificates } = state;
  return {
    tdsCertificates: RiderTdsCertificates.tdsCertificates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getTdsCertificates: bindActionCreators(
      RiderTdsCertificatesActions.getTdsCertificates,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverTdsCertificates);
